import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CustomerDetailService } from 'customers';
import { Observable, map } from 'rxjs';
import { OrderDetail, OrderDetailResult } from '../interfaces/order-detail.model';

@Injectable({ providedIn: 'root' })
export class OrderDetailService {
  private readonly http = inject(HttpClient);
  private readonly customerDetailService = inject(CustomerDetailService);

  getDetail(idOrdine: string): Observable<OrderDetailResult> {
    return this.read(this.http.get<OrderDetail>(`api/ordini/${idOrdine}`, { observe: 'response' }));
  }

  // Dal carrello della lista: anche le commesse nate fuori dall'App
  getDetailByCart(idCarrello: string): Observable<OrderDetailResult> {
    return this.read(this.http.get<OrderDetail>('api/ordini/erp', { params: { idCarrello }, observe: 'response' }));
  }

  // Gli alert arrivano nell'header come nella scheda cliente: si tengono quelli del cliente dell'ordine
  private read(request$: Observable<HttpResponse<OrderDetail>>): Observable<OrderDetailResult> {
    return request$.pipe(
      map(response => {
        const detail = response.body as OrderDetail;
        const header = this.customerDetailService.parseNotificationHeader(response.headers.get('x-contextnotification'));
        const alerts = (header?.Notifications ?? []).filter(n =>
          n.Category?.toLowerCase() === 'clienti' && n.CategoryId === detail.cliente?.idCliente);
        return { detail, alerts };
      }),
    );
  }
}
